import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

/**
 * @deprecated Media URLs are now served via pre-signed URLs from the backend.
 * Use MediaService.getMediaUrl(), the imageUrlAsync pipe, or the appImageSrc directive instead.
 */
@Pipe({
  name: 'imageUrl'
})
@Injectable({
  providedIn: 'root'
})
export class ImageUrlPipe implements PipeTransform {

  transform(imagePath: string): string {
    return `${environment.apiBaseImageUrl}${imagePath || ''}`;
  }

}
